module.exports = __webpack_public_path__ + "img/icon-list.e686785c.svg";